// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/index.tsx"); } },
  "./modal.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/modal.tsx"); } },
  "./p/[id].tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/p/[id].tsx"); } },
  "./packs.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/packs.tsx"); } },
  "./privacy.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/privacy.tsx"); } },
  "./terms.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/app/terms.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;